import { createSlice } from '@reduxjs/toolkit';

import { ISearchState } from 'store/types/searchTypes';
import * as reducers from 'store/reducers/searchReducer';

export const initialState: ISearchState = {
  currentSearchTerm: 'TERM_UNKNOWN',
  sizeSearchFilter: [],
  instantShipSearchFilter: false,
  conditionSearchFilter: [],
};

export const searchSlice = createSlice({ name: 'searchSlice', initialState, reducers });

export const { setCurrentSearchTerm, setSearchFiltersForPdp, clearSearchFiltersForPdp } =
  searchSlice.actions;
export default searchSlice.reducer;
